import { lazy } from 'react';

// ----------------------------------------------------------------------

const MaintenancePage = lazy(() => import('../pages/Maintenance.page'));
const MaintenanceListPage = lazy(() => import('../pages/MaintenanceList.page'));
const MaintenanceOrderPage = lazy(() => import('../pages/MaintenanceOrder.page'));
const MaintenanceEditPage = lazy(() => import('../pages/MaintenanceEdit.page'));
const MaintenanceCenters = lazy(() => import('../pages/MaintenanceCenters.page'));
const AddMaintenanceCenter = lazy(() => import('../pages/AddMaintenanceCenter.page'));
const MaintenanceCenterEditPage = lazy(() => import('../pages/MaintenanceCenterEdit.page'));

// ----------------------------------------------------------------------

const MaintenanceRoutes = [
    {
        path: 'maintenance',
        children: [
            {
                element: <MaintenancePage />,
                layout: 'default',
                isAuthReq: true,
                index: true,
            },
            {
                path: 'list',
                element: <MaintenanceListPage />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'order',
                element: <MaintenanceOrderPage />,
                layout: 'default',
                isAuthReq: true,
            },
            // {
            //     path: ':id',
            //     layout: 'default',
            //     isAuthReq: true,
            // },
            {
                path: ':id/edit',
                element: <MaintenanceEditPage />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'centers',
                children: [
                    { element: <MaintenanceCenters />, layout: 'default', isAuthReq: true, index: true },
                    {
                        path: 'add',
                        element: <AddMaintenanceCenter />,
                        layout: 'default',
                        isAuthReq: true,
                    },
                    {
                        path: ':id/edit',
                        element: <MaintenanceCenterEditPage />,
                        layout: 'default',
                        isAuthReq: true,
                    },
                ],
            },
        ],
    },
];

export { MaintenanceRoutes };
